import { getHeaders, getNonJsonHeaders, getNoAuthHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchHotel(id) {
  return fetch(`${host}/api/property/hotel/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchHotels() {
  return fetch(`${host}/api/property/hotel/?managed=true`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchHotelsSearch(search) {
  return fetch(`${host}/api/property/hotel/?search=${search}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchSuggestedHotels() {
  return fetch(`${host}/api/property/hotel/suggested/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function postPropertyAccount(payload) {
  if (payload.email) {
    // Send non-authorized request when registering
    return fetch(`${host}/api/property/register/`, {
      headers: getNoAuthHeaders(),
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }
  return fetch(`${host}/api/property/register/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function patchHotel(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function postHotelFeatures(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/features/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postHotelAddContact(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/add_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postHotelRemoveContact(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/remove_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postHotelClaim(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/claim/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchWaitlist() {
  return fetch(`${host}/api/property/wait_list/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function postWaitlist(payload) {
  return fetch(`${host}/api/property/wait_list/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postPhotoSort(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/sort/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function patchPhoto(id, payload) {
  return fetch(`${host}/api/property/photo/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function uploadHotelImage(payload) {
  const formData = new FormData();
  formData.append('hotel', payload.hotel);
  if (payload.order) {
    formData.append('order', payload.order);
  }
  if (payload.name) {
    formData.append('name', payload.name);
  }
  formData.append('photo', payload.files[0]);
  return fetch(`${host}/api/property/photo/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}
export function deleteHotelPhoto(id) {
  return fetch(`${host}/api/property/photo/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}



// WEBPACK FOOTER //
// src/routes/hotels/modules/api.js